import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from '../services/auth.service';
import {ActionResultClass} from '../model/search-result';
import {DialogService} from '../services/dialog/dialog.service';

@Component({
  selector: 'app-aad-login',
  template: ''
})
export class AadLoginComponent implements OnInit {
  private sysMessage: string;

  constructor(
    private httpClient: HttpClient,
    private activatedRoute: ActivatedRoute,
    private authService: AuthService,
    private dialogService: DialogService) { }

  ngOnInit() {
    const applicationId = this.activatedRoute.snapshot.queryParamMap.get('appID');
    const redirectUri = this.activatedRoute.snapshot.queryParamMap.get('redirectUri');
    const errorRedirectUri = this.activatedRoute.snapshot.queryParamMap.get('errorRedirectUri');
    console.log({applicationId, redirectUri, errorRedirectUri});
    this.authService.AuthenticateAAD(applicationId, redirectUri, errorRedirectUri, this.successCallBack, this.errorCallBack);
  }

  successCallBack = (response: ActionResultClass) => {
    this.sysMessage = 'login ok';
  }

  errorCallBack = (res: ActionResultClass) => {
    this.sysMessage = res ? res.message : 'error';
    this.dialogService.ErrorInformation(this.sysMessage)
      .then(() => true)
      .catch((error) => console.log('LO3001', error));
  }
}
